<h2 mat-dialog-title class="flex items-center gap-2">
  <mat-icon>info</mat-icon>
  <span>Informations</span>
</h2>

<mat-dialog-content class="w-full">
  <!-- Empty state -->
  <div
    *ngIf="sections.length === 0"
    class="flex flex-col items-center justify-center py-8 text-gray-500"
  >
    <mat-icon class="text-4xl mb-2">info</mat-icon>
    <p>Aucune information disponible</p>
  </div>

  <!-- Sections list -->
  <mat-accordion *ngIf="sections.length > 0" class="h-full" multi>
    <mat-expansion-panel
      *ngFor="let section of sections; let i = index"
      [expanded]="i === 0"
    >
      <mat-expansion-panel-header>
        <mat-panel-title class="font-medium">
          {{ section.name }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="py-2">
        <quill-view
          [content]="section.content"
          format="html"
          theme="snow"
          class="h-full"
        ></quill-view>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Fermer</button>
</mat-dialog-actions>
